import { ElementRef } from '@angular/core';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-movie-viewer-vimeo',
  templateUrl: './movie-viewer-vimeo.component.html',
  styleUrls: ['./movie-viewer-vimeo.component.css']
})
export class MovieViewerVimeoComponent implements OnInit {

  public mov_vc_uri:string;
  
  constructor(
    public dialogRef: MatDialogRef<MovieViewerVimeoComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any,
    private elementRef:ElementRef
  ) { 
    this.mov_vc_uri = data;
    
  }

  ngOnInit(): void {
     
    var d1 = this.elementRef.nativeElement.querySelector('.mov_mod_in_id');
    d1.insertAdjacentHTML('beforeend', this.mov_vc_uri);
     
 
  }

}
